import axios from 'axios';
import {
  call,
  put,
  cancel
} from 'redux-saga/effects';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import {
  setOverlay,
  setOverlayData
} from '../../redux/modules/overlay/overlay';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  updateGlobalSpinner,
  setError,
	setPageErrors,
	setConsumerType
} from '../../redux/modules/common/common';
import {
  errorTypes,
  HANDLE_ERROR
} from '../../redux/modules/pages/error/error';
import {
  navigationRoutes,
  navigationSteps
} from '../../redux/modules/navigation/navigationHelpers';
import contentProvider from '../../redux/modules/contentProvider/contentProvider';
import {
  ANALYTICS_DATA_RECEIVED,
  ANALYTICS_ERRORS_RECEIVED
} from '../../redux/modules/dataLayer/dataLayer';

export const responseStatus = {
  SUCCESS : 'Success',
  ERROR : 'Error',
  REDIRECT : 'Redirect',
  OVERLAY: 'Overlay'
};

export const defaults = {
  url: '',
  method: 'GET',
  data: undefined,
  timeout: 150000,
  useGlobalSpinner: true,
  hideContentWhileLoading: true,
  fetchCustomizationTypesIfNotFetched: false,
  clearPageErrors: true,
  showPageLevelError: true,
  spinnerInitiater: 'loader',
  redirectOnError: true,
  withCredentials: false,
  errorPage: navigationRoutes[navigationSteps.myPlan.ERROR].path,
  spinnerMessage: '',
  preLoad: () => {},
  postLoad: () => {},
  postLoadOnError: true,
  headers: {
    'access-control-allow-origin': window.location.hostname
  }
} ;

export const requestConfigKeys = [
  'url',
  'method',
  'data',
  'timeout',
  'headers',
  'withCredentials'
];

class Loader {

   *request (endpoint, opts) {
    let config = Object.assign({}, defaults, opts, endpoint);
    const requestConfig = Object.assign({}, _.pick(config, requestConfigKeys));

    function* redirect (redirectUrl, externalRedirect) {
      if (!redirectUrl) {
        return false;
      }

      if (redirectUrl.indexOf('/') === 0 && !externalRedirect) {
        yield call(browserHistory.push, redirectUrl);
        return true;
      }

      if (redirectUrl.indexOf('/') === 0 && externalRedirect) {
        window.location = redirectUrl;
        return true;
      }

      window.location = `//${redirectUrl}`;
      return true;
    }

    function* preLoad() {
      if (config.useGlobalSpinner) {
        yield put(showGlobalSpinner({message:config.spinnerMessage, hideContent: config.hideContentWhileLoading, spinnerInitiater: config.spinnerInitiater}));
      }

      if (!config.useGlobalSpinner) {
        yield put(updateGlobalSpinner({message:config.spinnerMessage}));
      }

      if (config.clearPageErrors) {
        yield put(setPageErrors([]));
      }
      yield call(config.preLoad);
    }

    function* postLoad(data) {
      if (config.useGlobalSpinner) {
        yield put(hideGlobalSpinner(config.spinnerInitiater));
      }
      yield call(config.postLoad, data);
    }

    let response;

    yield call(preLoad);

    try {
      response = yield call(axios, requestConfig);
    } catch(e) {
      yield put(setError(e));
      if (config.postLoadOnError) {
        yield call(postLoad);
      }
      if (config.redirectOnError) {
        yield put({
          type: HANDLE_ERROR,
          errorType: errorTypes.EXCEPTION,
          endpointUrl: requestConfig.url,
          content: e
        });
        yield call(browserHistory.push, config.errorPage);
        yield put(hideGlobalSpinner());
      }
      throw new Error(JSON.stringify(e));
    }
    const {data} = response;

    if (data.analyticsData) {
      yield put({
        type: ANALYTICS_DATA_RECEIVED,
        payload: {analyticsData:data.analyticsData}
      });
    }

    yield call(postLoad, data);
    const status = data.responseStatus;
    const redirectUrl = data.redirectUrl;
    const externalRedirect = data.externalRedirect;

    switch (status) {
      case responseStatus.REDIRECT: {
        const redirecting = yield call(redirect, redirectUrl, externalRedirect);

        yield put(setError(data));
				yield put(setPageErrors([]));

				if (data.consumerType) {
					yield put(setConsumerType(data.consumerType));
				}

        if (!_.isEmpty(data.errors)) {
          const errorMessages = data.errors
            .map(error => error.errorCode === '' ? error.userMessage : contentProvider.getValue(`errors.${error.errorCode}`,
              [], `Unmapped error: ${error.errorCode} - field: ${error.errorField}`));

          yield put({
            type: ANALYTICS_ERRORS_RECEIVED,
            payload: {errorMessages}
          });
				}
        if (redirecting) {
          yield cancel();
				}
        yield call(browserHistory.push, config.errorPage);
        throw new Error('generator error');
      }

      case responseStatus.ERROR: {

        const errorMessages = data.errors
          .map(error => error.errorCode === '' ? error.userMessage : contentProvider.getValue(`errors.${error.errorCode}`,
            [], `Unmapped error: ${error.errorCode} - field: ${error.errorField}`));

        yield put({
          type: ANALYTICS_ERRORS_RECEIVED,
          payload: {errorMessages}
        });

        if (config.showPageLevelError) {
          // HACK: window.scrollTo isn't scrolling to top
          document.getElementById('polaris-nav-header-wrapper').scrollIntoView();
          //yield call(window.scrollTo, 0, 0);

          yield put(setPageErrors(errorMessages));
        }
        throw ({error:'generator error', data});
      }

      case responseStatus.OVERLAY: {
        yield put(setOverlayData(data.overlay, data.overlayData));
        yield put(setOverlay(data.overlay, true));

        throw ({error:'overlay launched', data});
      }

      case responseStatus.SUCCESS:
      default:
        return data;
    }
  }
}

//Ensure only a singleton is exported
const instance = new Loader();

export default instance;



/** WEBPACK FOOTER **
 ** ./client/util/loader/loader.js
 **/